import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
    width: ${props => props.width};
    height: ${props => props.height};
    background-color: #bbb;
    cursor: pointer;
    color: white;

    @media (max-width: 1000px) {
        width: ${props => props.shouldShrinkOnMobile ? "300px" : props.width};
        height: ${props => props.shouldShrinkOnMobile ? "300px" : props.height};
    }

    div {
        padding: 40px;
        display: flex;
        justify-content: center;
        align-items: end;
        height: 100%;
        background-image: url('/img/croix_blanche.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 30px;
    }
`;

const AddAnItem = (props) => {

    const { i18n } = useTranslation('common');

    let shouldShrinkOnMobile = false;
    if(props.width === "400px" && props.height === "400px") {
        shouldShrinkOnMobile = true;
    }

    return (
        <div>
            <Container onClick={props.onClick} width={props.width} height={props.height} shouldShrinkOnMobile={shouldShrinkOnMobile}>
                <div><span>{i18n.language === 'fr' ? ("Ajouter " + props.textFR) : ("Add " + props.textEN)}</span></div>
            </Container>
        </div>
    );
};

export default AddAnItem;
